module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/languages/en.json
// module id = czGY
// module chunks = 1